import React from 'react';

const getColumns = (structuredData) => {
    if (Array.isArray(structuredData?.columns)) {
        return structuredData.columns;
    }

    if (Array.isArray(structuredData?.headers)) {
        return structuredData.headers.map((header) => ({ key: header, title: header }));
    }

    return [];
};

const getRows = (structuredData) => {
    if (Array.isArray(structuredData?.rows)) {
        return structuredData.rows;
    }

    if (Array.isArray(structuredData?.data)) {
        return structuredData.data;
    }

    return [];
};

const getCellValue = (row, column) => {
    if (row && typeof row === 'object' && !Array.isArray(row)) {
        const lookupKey = column.key || column.title;
        return row[lookupKey];
    }

    if (Array.isArray(row) && typeof column.index === 'number') {
        return row[column.index];
    }

    return '';
};

const TableMessage = ({ structuredData }) => {
    const columns = getColumns(structuredData).map((column, index) => {
        if (typeof column === 'string') {
            return { key: column, title: column, index };
        }

        return {
            key: column?.key || column?.dataIndex || column?.title || `column-${index}`,
            title: column?.title || column?.label || column?.key || `Column ${index + 1}`,
            index
        };
    });
    const rows = getRows(structuredData);

    return (
        <div className='copilot-chat-message copilot-chat-message--structured assistant'>
            <div className='copilot-chat-table-container'>
                <table className='copilot-chat-table'>
                    <thead>
                        <tr>
                            {columns.map((column) => <th key={column.key}>{column.title}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => {
                            return (
                                <tr key={`row-${rowIndex}`}>
                                    {columns.map((column) => {
                                        return <td key={`${column.key}-${rowIndex}`}>{String(getCellValue(row, column) ?? '')}</td>;
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableMessage;
